'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var NotificationCTA = function (_React$Component) {
  _inherits(NotificationCTA, _React$Component);

  function NotificationCTA() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationCTA);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationCTA.__proto__ || Object.getPrototypeOf(NotificationCTA)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { level: '4', className: 'notification-ribbon__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _this.renderTertiaryCta = function (tertiaryCta) {
      if (tertiaryCta) {
        var targetValue = tertiaryCta.target || '_self';
        return _react2.default.createElement(
          _button2.default,
          {
            id: tertiaryCta.id,
            href: tertiaryCta.href,
            className: 'notification-ribbon__cta',
            fpti: 'NtfnRbn-PrmryCTA-' + tertiaryCta.text,
            color: 'outline-blue',
            size: 'small',
            target: targetValue
          },
          tertiaryCta.text
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationCTA, [{
    key: 'render',
    value: function render() {
      var _props$content = this.props.content,
          headline = _props$content.headline,
          tertiaryCta = _props$content.tertiaryCta;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        this.renderHeadline(headline),
        this.renderTertiaryCta(tertiaryCta)
      );
    }
  }]);

  return NotificationCTA;
}(_react2.default.Component);

exports.default = NotificationCTA;


NotificationCTA.propTypes = {
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    tertiaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }).isRequired
  })
};

NotificationCTA.defaultProps = {
  content: {
    headline: {
      text: 'Text introduces CTA or QR code'
    },
    tertiaryCta: {
      id: '',
      text: '24 characters maximum',
      href: '#',
      target: '_self'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/notification-ribbon-cta/jsx/NotificationCTA.js
// module id = 668
// module chunks = 4